export default __webpack_public_path__ + "static/media/logo-pinjam-modal-small.edd67f44.png";